import _ from "lodash";
import makeApp from "./jsGenerator";

export function reindent(str, offset = 0, space = 2) {
  const lines = str.split("\n");
  const transform = (l) => _.times(space, _.constant(" ")).join("") + l;
  if (offset === 0) return lines.map(transform).join("\n");
  return [
    ...lines.slice(0, offset),
    ...lines.slice(offset).map(transform),
  ].join("\n");
}

export function singleFile(tree) {
  const css = generateCSS(tree);
  const js = generateJS(tree);
  const styles = "    <style>\n" + reindent(css, 0, 6) + "\n    </style>";
  const scripts = "    <script>\n" + reindent(js, 0, 6) + "\n    </script>";
  return {
    styles,
    scripts,
  };
}

function splitFile() {
  const styles = '    <link rel="stylesheet" type="text/css" href="/main.css">';
  const scripts = '    <script src="/main.js"></script>';
  return {
    styles,
    scripts,
  };
}

export function generateHTML(tree, process = splitFile) {
  const { styles, scripts } = process(tree);
  const { title, stylesheets } = tree;
  let html = [
    `<doctype html>
<html>
  <head>`,
  ];
  if (title) html.push(`<title>${title}</title>`);
  if (stylesheets)
    html.push(
      stylesheets
        .map((s) => `    <link href="${s}" rel="stylesheet" type="text/css" />`)
        .join("\n")
    );
  html.push(`${styles}
  </head>
  <body>
    <div id="root"></div>
${scripts}
  </body>
</html>`);
  return html.join("\n");
}

export function generateSingleHTML(tree) {
  return generateHTML(tree, singleFile);
}

export function generateCSS(tree) {
  return `html, body, #root {
  height: 100%;
}
.ls {
  display: flex;
  position: relative;
}
.ls.v {
  flex-direction: column;
  height: 100%;
}
.pn {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 4px;
  flex-direction: column;
  min-width: 200px;
}
.pn-h {
  height: 20px;
  border-bottom: 1px solid #ccc;
}
.pn-b {
  min-height: 200px;
  flex: 1;
  display: flex;
  justify-content: center;
}
.pn-b.c {
  align-items: center;
}
.pn-b > .da {
  flex: 1;
}`;
}

export function generateJS(tree) {
  const appCode = makeApp(tree);
  return `${appCode}\n\ndocument.addEventListener('DOMContentLoaded', function() {
  const app = new App()
  const root = document.getElementById('root');
  root.appendChild(app.ref)
})`;
}

/**
 *
 * @param {object} tree
 * @return {object}
 */
export function generateCode(tree) {
  const html = generateHTML(tree);
  const css = generateCSS(tree);
  const js = generateJS(tree);
  return {
    html,
    css,
    js,
  };
}
